import Icon from '@ant-design/icons';

const Heading3 = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66675 13.6667V2.43552H3.15988V7.48936H7.64592V2.43552H9.14307V13.6667H7.64592V8.74102H3.15988V13.6667H1.66675Z"
        fill="currentColor"
      />
      <path
        d="M12.0955 13.667C11.6717 13.667 11.3015 13.5893 10.9851 13.4341C10.6746 13.2789 10.4328 13.061 10.2597 12.7804C10.0866 12.4998 10 12.1684 10 11.7863H11.1284C11.1284 12.0789 11.2119 12.3087 11.3791 12.4759C11.5523 12.6371 11.794 12.7177 12.1045 12.7177C12.4149 12.7177 12.6538 12.6341 12.8209 12.4669C12.9881 12.2998 13.0717 12.0729 13.0717 11.7863V11.2759C13.0717 10.9834 12.9881 10.7565 12.8209 10.5953C12.6538 10.4281 12.4149 10.3445 12.1045 10.3445H11.3702V9.33259L12.812 7.99826H10.2955V7.04004H13.9493V8.05199L12.1045 9.74454V9.38633C12.7493 9.38633 13.2597 9.55648 13.6358 9.89678C14.012 10.2371 14.2 10.6968 14.2 11.2759V11.7863C14.2 12.1684 14.1135 12.4998 13.9403 12.7804C13.7672 13.061 13.5224 13.2789 13.206 13.4341C12.8896 13.5893 12.5194 13.667 12.0955 13.667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Heading3Icon = (props: any) => <Icon component={Heading3} {...props} />;
